import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import Label from '../../label';
import { INPUT_GAP_SIZES } from '../styles';

export const DateControlsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium};
    display: flex;
    flex-flow: row wrap;
    grid-column: 1 / 3; // Take up 2 columns of the parent grid

    .react-date-picker__calendar {
        z-index: 2;
    }
`;

export const TimeControls = styled.div`
    ${BaseStyle.Mixins.gaps.semiMedium};
    display: flex;
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.gaps.medium};
    }

    input {
        height: 12px;
    }
`;

export const LabelledInputContainer = styled.div`
    align-items: center;
    display: flex;

    input:checked {
        accent-color: ${({ theme }) => theme.Surface.Opposite.primary};
    }
`;

export const SumResultsContainer = styled(LabelledInputContainer)`
    flex: 1;
    justify-content: end;
`;

export const TimeSelectContainer = styled.div`
    display: flex;
    width: 100%;

    div {
        flex: 1;
    }
`;

export const InlineLabel = styled(Label)`
    display: inline-block;
    margin-left: 4px;
`;

export const InputSeparator = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${INPUT_GAP_SIZES.medium}px;

    ${BaseStyle.Mixins.screenSizes.large} {
        width: ${INPUT_GAP_SIZES.large}px;
    }

    ${BaseStyle.Mixins.screenSizes.extraLarge} {
        width: ${INPUT_GAP_SIZES.extraLarge}px;
    }
`;
